import { lazy } from 'react';
import { lazyRetry } from '../../utils/general';
const Navbar = lazy(() => lazyRetry(() => import('./Navbar')));
export { Navbar };
